import Vue from 'vue'
import Vuex from 'vuex'

import * as getters from './getters'
import * as actions from './actions'
import * as mutations from './mutations'

Vue.use(Vuex)

const state = {
  queryConfig: null, // 请求配置
  voteInfo: null, // 投票信息
  jwt: "",
  orgid: "",
  voteText: "投票",
  activeTab: 0, // 投票组相关，用于切换标签时，传递给rank
  pageTrackingOptions: null // 页面埋点配置 
}

export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
})
